import { render, staticRenderFns } from "./CompArticleText.vue?vue&type=template&id=b90c2c56&scoped=true"
import script from "./CompArticleText.vue?vue&type=script&setup=true&lang=js"
export * from "./CompArticleText.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompArticleText.vue?vue&type=style&index=0&id=b90c2c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90c2c56",
  null
  
)

export default component.exports